const isExpired = (endDate)=>{
    if (!endDate) return false;
            
    const endDateObj = new Date(endDate);
    // Set time to 23:59:59 on end date
    endDateObj.setHours(23, 59, 59, 999);
    
    return endDateObj < new Date();
};

export default isExpired